import { Controller } from "@hotwired/stimulus"

// CPD rerun wizard — companion to the generic v2-stepper.
// Validates each step before allowing advance and writes summaries.
export default class extends Controller {
  static targets = [
    "destinationCheckbox",
    "includeDeliveredInput",
  ]

  static outlets = ["v2-stepper"]

  // Capture updated range from the shared V2 date-range picker
  dateChanged(event) {
    this._dateFrom = event.detail.from
    this._dateTo = event.detail.to
  }

  validate(event) {
    const step = event.detail.step
    let valid = true

    switch (step) {
      case 1:
        valid = this.destinationCheckboxTargets.some((cb) => cb.checked)
        break
      case 2: {
        const [from, to] = this._currentRange()
        valid = this._isISODate(from) && this._isISODate(to)
        break
      }
    }

    if (!valid) event.preventDefault()
  }

  stepChanged(event) {
    const stepper = this.v2StepperOutlet
    if (!stepper) return
    for (let i = 1; i < event.detail.step; i++) {
      stepper.setSummary(i, this.summaryForStep(i))
    }
  }

  summaryForStep(step) {
    switch (step) {
      case 1: {
        const total = this.destinationCheckboxTargets.length
        const count = this.destinationCheckboxTargets.filter((cb) => cb.checked).length
        if (count === total) return `All ${total} destinations`
        return `${count} of ${total} destinations`
      }
      case 2: {
        const [from, to] = this._currentRange()
        return from && to ? `${from} to ${to}` : ""
      }
      case 3:
        return this.includeDeliveredInputTarget?.checked
          ? "Including already-delivered"
          : "Failed/expired only"
      default:
        return ""
    }
  }

  _currentRange() {
    const form = this.element.closest("form")
    const from = form?.querySelector('input[name="cpd_management_rerun_request[since]"]')?.value
    const to = form?.querySelector('input[name="cpd_management_rerun_request[until_date]"]')?.value
    return [from, to]
  }

  _isISODate(value) {
    if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false
    const d = new Date(value + "T00:00:00")
    return !isNaN(d.getTime())
  }
}
